/**
 * @description Get ULID from path or iri reference
 */
const getULID = (path?: string | null) => {
  const regex = /01([A-Z0-9]){24}/;

  return path?.match(regex)?.[0] ?? null;
};

export default getULID;
